import type { DataSourceId } from 'cadenza/repository/data-source-id';
import type { ObjecttypeId } from 'cadenza/repository/objecttype-id';
import type { AttributeId } from 'cadenza/workbook/api/attribute-id';

export const ObjecttypeBoundState = {
  /** Objecttype is not bound.*/
  UNBOUND: 'UNBOUND',
  /** Objecttype is bound in a transient state to the workbook.*/
  TRANSIENT: 'TRANSIENT',
  /** Objecttype is bound to the workbook.*/
  BOUND_TO_WORKBOOK: 'BOUND_TO_WORKBOOK'
} as const;

export type ObjecttypeBoundState = keyof typeof ObjecttypeBoundState;

export interface Objecttype {
  id: ObjecttypeId;
  printName: string;
  /** Name of data source this object type belongs to. */
  dataSourceId: DataSourceId;
  /** IDs of reachable object types. */
  reachableObjecttypes: string[];
  /** IDs of reachable object with one to one association types. */
  reachableObjecttypesWithOneToOneAssociation: string[];
  attributes: AttributeId[];
  /** Map of objecttype related properties. */
  properties?: { [x: string]: string | number | boolean | null };
  /**
   * If true the objecttype generally allows data acquisition including adding, editing and
   * deletion of features.
   */
  dataAcquisitionPossible: boolean;
  /** Bound state of this object type */
  boundState: ObjecttypeBoundState;
}
